// extracted by mini-css-extract-plugin
export default {"moreGrants":"user-access-cell_moreGrants__34V2t"};